import React from "react";

const CountriesDropDown = (props) => {
    //props:
    //elmdId: the id and key to use for the dropdown
    //countryItems: string array of countries
    //selectedCountry: string
    //onCountryChange event: returns country value as parameter.
    
    return (
        <select key={props.elmId} id={props.elmId} onChange={(e) => props.onCountryChange(e.target.value)}>
            <option key="any" value="">Any</option>
            {props.countryItems.map(country => {
                return <option key={country} value={country} selected={props.selectedCountry === country}>{country}</option>
            })}
        </select>
    )
}

export default CountriesDropDown;